const Main = () => import('../../pages/main')
const Intelligence = () => import('../../pages/Ai/AiVideo')
const AiContent = () => import('../../pages/Ai/AiContent')
const AiKeywords = () => import('../../pages/Ai/AiKeywords')
const AiTask = () => import('../../pages/Ai/AiTask')
const AiDialogue = () => import('../../pages/Ai/AiDialogue')

export default [{
	path: '/ai',
	component: Main,
	meta: {
		requiresAuth: true,
		hidden: true,
		title: 'AI内容创作',
		icon: 'icon-nav-ai',
		sideNav: true
	},
	children: [
		{
			name: 'AiVideo',
			path: 'video',
			component: Intelligence,
			meta: {
				requiresAuth: true,
				hidden: false,
				title: '视频混剪',
			}
		},
		{
			name: 'AiContent',
			path: 'content',
			component: AiContent,
			meta: {
				requiresAuth: true,
				hidden: false,
				title: 'AI智能文章',
			}
		},
		{
			name: 'AiKeywords',
			path: 'keywords',
			component: AiKeywords,
			meta: {
				requiresAuth: true,
				hidden: false,
				title: '关键词管理',
			}
		},
		{
			name: 'aiTask',
			path: 'aiTask',
			component: AiTask,
			meta: {
				requiresAuth: true,
				hidden: false,
				title: 'AI智能运营',
			}
		},
		// {
		// 	name: 'AiDialogue',
		// 	path: 'dialogue',
		// 	component: AiDialogue,
		// 	meta: {
		// 		requiresAuth: true,
		// 		hidden: false,
		// 		title: 'AI互动(内测版)',
		// 	}
		// }
	]
}]
